import type { ChipFiltersSearchParametersSelectorMap } from '@features/filters/chipBasedFilters/types';

import {
  CHIP_FILTERS_ENTITY,
  CHIPS_ALLOWED_MODULE,
} from '@features/filters/types';

const {
  ID,
  CODE,
  TYPE,
  STATUS,
  CODE_ID,
  BRAND_ID,
  CATEGORY,
  GIVEN_AT,
  GIVEN_TO,
  OFFER_ID,
  CURRENCY,
  PLAYER_ID,
  ISSUED_BY,
  APPLIED_AT,
  APPLIED_TO,
  COUNTRY_ID,
  EXPIRES_AT,
  EXPIRES_TO,
  CAMPAIGN_ID,
  FILTER_TYPE,
  DECLINED_AT,
  DECLINED_TO,
  ACCEPTED_AT,
  ACCEPTED_TO,
  PAYOUT_TYPE,
  ACTIVATED_AT,
  ACTIVATED_TO,
  CANCELLED_AT,
  CANCELLED_BY,
  CANCELLED_TO,
  CONVERTED_AT,
  CONVERTED_TO,
  ISSUED_BY_ID,
  APPLIED_BY_ID,
  BET_REFERENCE,
  TRANSACTION_ID,
  ISSUING_METHOD,
  CANCELLED_BY_ID,
  GIVEN_AMOUNT_AT,
  GIVEN_AMOUNT_TO,
  BONUS_TEMPLATE_ID,
  CONVERTED_AMOUNT_AT,
  CONVERTED_AMOUNT_TO,
  PROFIT_BOOST_PERCENTAGE,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_AT,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_TO,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_AT,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_TO,
} = CHIP_FILTERS_ENTITY;

export const CHIP_FILTER_AMOUNT_DECIMAL_PLACES_MAX = 2;
export const CHIP_FILTER_INPUT_VALUE_MAX_LENGTH = 255;

export const inputTypeFilters = [
  PLAYER_ID,
  CODE,
  ID,
  BET_REFERENCE,
  CAMPAIGN_ID,
  BONUS_TEMPLATE_ID,
  GIVEN_AMOUNT_AT,
  GIVEN_AMOUNT_TO,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_AT,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_TO,
  TRANSACTION_ID,
  OFFER_ID,
  CANCELLED_BY,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_AT,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_TO,
  CONVERTED_AMOUNT_AT,
  CONVERTED_AMOUNT_TO,
  CODE_ID,
  ISSUED_BY,
  PROFIT_BOOST_PERCENTAGE,
];

export const startDateTypeFilters = [
  APPLIED_AT,
  ACTIVATED_AT,
  DECLINED_AT,
  ACCEPTED_AT,
  GIVEN_AT,
  EXPIRES_AT,
  CANCELLED_AT,
  CONVERTED_AT,
];

export const endDateTypeFilters = [
  APPLIED_TO,
  EXPIRES_TO,
  ACTIVATED_TO,
  CANCELLED_TO,
  GIVEN_TO,
  DECLINED_TO,
  ACCEPTED_TO,
  CONVERTED_TO,
];

export const offerReportEnabledFilters = [
  ID,
  STATUS,
  BRAND_ID,
  CATEGORY,
  GIVEN_AT,
  GIVEN_TO,
  PLAYER_ID,
  COUNTRY_ID,
  EXPIRES_AT,
  EXPIRES_TO,
  ACCEPTED_AT,
  ACCEPTED_TO,
  CAMPAIGN_ID,
  DECLINED_AT,
  DECLINED_TO,
  FILTER_TYPE,
] as const satisfies readonly CHIP_FILTERS_ENTITY[];

export const codeReportEnabledFilters = [
  ID,
  CODE,
  STATUS,
  BRAND_ID,
  CATEGORY,
  PLAYER_ID,
  APPLIED_AT,
  APPLIED_BY_ID,
  APPLIED_TO,
  COUNTRY_ID,
  EXPIRES_AT,
  EXPIRES_TO,
  CAMPAIGN_ID,
  FILTER_TYPE,
  ACTIVATED_AT,
  ACTIVATED_TO,
  CANCELLED_AT,
  CANCELLED_BY,
  CANCELLED_BY_ID,
  CANCELLED_TO,
] as const satisfies readonly CHIP_FILTERS_ENTITY[];

export const bonusReportEnabledFilters = [
  ID,
  TYPE,
  STATUS,
  COUNTRY_ID,
  CODE_ID,
  BRAND_ID,
  CURRENCY,
  GIVEN_AT,
  GIVEN_TO,
  OFFER_ID,
  CATEGORY,
  PLAYER_ID,
  ISSUED_BY,
  ISSUED_BY_ID,
  EXPIRES_AT,
  EXPIRES_TO,
  CAMPAIGN_ID,
  FILTER_TYPE,
  PAYOUT_TYPE,
  CANCELLED_AT,
  CANCELLED_BY,
  CANCELLED_BY_ID,
  CANCELLED_TO,
  CONVERTED_AT,
  CONVERTED_TO,
  BET_REFERENCE,
  ISSUING_METHOD,
  TRANSACTION_ID,
  GIVEN_AMOUNT_AT,
  GIVEN_AMOUNT_TO,
  PROFIT_BOOST_PERCENTAGE,
  BONUS_TEMPLATE_ID,
  CONVERTED_AMOUNT_AT,
  CONVERTED_AMOUNT_TO,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_AT,
  GIVEN_AMOUNT_SYSTEM_CURRENCY_TO,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_AT,
  CONVERTED_AMOUNT_SYSTEM_CURRENCY_TO,
] as const satisfies readonly CHIP_FILTERS_ENTITY[];

export const enabledFieldsPerReportMap = {
  [CHIPS_ALLOWED_MODULE.CODE]: codeReportEnabledFilters,
  [CHIPS_ALLOWED_MODULE.OFFERS]: offerReportEnabledFilters,
  [CHIPS_ALLOWED_MODULE.BONUSES]: bonusReportEnabledFilters,
};

export const chipFiltersSearchParametersSelectorMap: ChipFiltersSearchParametersSelectorMap =
  {
    [CHIPS_ALLOWED_MODULE.CODE]: (state) => state.playerCodes.searchParameters,
    [CHIPS_ALLOWED_MODULE.OFFERS]: (state) =>
      state.playerOffers.searchParameters,
    [CHIPS_ALLOWED_MODULE.BONUSES]: (state) =>
      state.playerBonuses.searchParameters,
  };
